export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "it", "zh"];

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "fr", label: "Français" },
  { value: "it", label: "Italiano" },
  { value: "zh", label: "中文" },
];

export function normalizeLanguageCode(languageCode, fallback = "en") {
  if (typeof languageCode !== "string") return fallback;

  const normalized = languageCode.trim().toLowerCase();
  if (!normalized) return fallback;

  return normalized.split("-")[0] || fallback;
}

export function getSupportedLanguageCode(languageCode, fallback = "en") {
  const normalized = normalizeLanguageCode(languageCode, fallback);
  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : fallback;
}

export function getIntlLocale(languageCode) {
  switch (getSupportedLanguageCode(languageCode)) {
    case "es":
      return "es-ES";
    case "fr":
      return "fr-FR";
    case "it":
      return "it-IT";
    case "zh":
      return "zh-CN";
    case "en":
    default:
      return "en-US";
  }
}
